import { render, staticRenderFns } from "./SimpleMessage.vue?vue&type=template&id=b0781d88&scoped=true"
import script from "./SimpleMessage.vue?vue&type=script&lang=js"
export * from "./SimpleMessage.vue?vue&type=script&lang=js"
import style0 from "./SimpleMessage.vue?vue&type=style&index=0&id=b0781d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0781d88",
  null
  
)

export default component.exports